// extracted by mini-css-extract-plugin
module.exports = {"Layout":"MainLayout_Layout__2Y4Gl"};